import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (13 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisMagaza = {

  // Mağaza promosyon kodları (API: promo-codes.php). Liste/ekle/düzenle/sil yalnız admin;
  // Validate her oturuma açık (mağaza ödeme ekranı). payload alanları camelCase:
  // code, description, discountType ('percent'|'amount'), discountValue, minCartAmount,
  // maxDiscountAmount, shippingIncluded, expiresAt (unix sn, boş=süresiz), usageLimit (boş=limitsiz), status (1|2).
  StorePromoCodesList(token) {
    return axios({ method: "post", url: `${API_URL}flow/store-promo-codes-list`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
  },
  StorePromoCodeCreate(token, payload) {
    return axios({ method: "post", url: `${API_URL}flow/store-promo-code-create`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: payload });
  },
  StorePromoCodeUpdate(token, payload) {
    return axios({ method: "post", url: `${API_URL}flow/store-promo-code-update`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: payload });
  },
  StorePromoCodeDelete(token, promoCodeID) {
    return axios({ method: "post", url: `${API_URL}flow/store-promo-code-delete`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { promoCodeID } });
  },
  StorePromoCodeValidate(token, code, cartTotal, shippingTotal = 0) {
    return axios({ method: "post", url: `${API_URL}flow/store-promo-code-validate`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { code, cartTotal, shippingTotal } });
  },

  // 2. el ilan onayı (API: store.php / store-ext.php). Onay kuyruğu, onay/red ve durum
  // değişikliği yalnız admin. İlan durumları: 0 taslak (ödeme bekliyor), 1 onay bekliyor,
  // 2 yayında, 3 reddedildi, 4 süresi doldu/pasif, 5 satıldı, -1 kaldırıldı.
  StoreListingsForReview(token, { status = 1, limit = 50, offset = 0 } = {}) {
    return axios({ method: "post", url: `${API_URL}flow/get-listings-for-review`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { status, limit, offset } });
  },
  StoreGetListing(token, listingID) {
    return axios({ method: "post", url: `${API_URL}flow/get-listing`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID } });
  },
  // Satış izni (store-ext, admin): yalnız açık ilanlar sepete eklenir / satın alınır. Müşteriye gösterilmez.
  StoreSetListingOpenToSale(token, listingID, openToSale) {
    return axios({ method: "post", url: `${API_URL}flow/set-listing-open-to-sale`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID, openToSale } });
  },
  // Toplu kapak görseli (store-ext): {covers: {listingID: url}}. Görüntülenme sayacını artırmaz.
  StoreGetListingCovers(token, listingIDs) {
    return axios({ method: "post", url: `${API_URL}flow/get-listing-covers`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingIDs } });
  },
  StoreGetListingExtras(token, listingID) {
    return axios({ method: "post", url: `${API_URL}flow/get-listing-extras`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID } });
  },
  // Onay: ilanı yayına alır + satıcıya 500 TL nakliye indirim kodu üretip mailler.
  StoreApproveListing(token, listingID) {
    return axios({ method: "post", url: `${API_URL}flow/approve-listing`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID } });
  },
  // Red: reason ZORUNLU (en az 5 karakter), satıcıya aynen maillenir.
  StoreRejectListing(token, listingID, reason) {
    return axios({ method: "post", url: `${API_URL}flow/reject-listing`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID, reason } });
  },
  StoreSetListingStatus(token, listingID, status) {
    return axios({ method: "post", url: `${API_URL}flow/set-listing-status`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { listingID, status } });
  },
};

export default servisMagaza;
